import { Component, Input, OnInit } from '@angular/core';
import { Links, Options, Question, Survey } from '../shared/model-service';
import { PopupService } from '../shared/popup-service';
import { SurveyAnswerService } from '../../public-api';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'lib-length-of-time',
  templateUrl: './length-of-time.component.html',
  styleUrls: ['./length-of-time.component.css']
})
export class LengthOfTimeComponent implements OnInit {

  panelOpenState = true;
  show: boolean = false;
  timer: any;

  @Input() Question : Question;
  @Input() SurveyBase : Survey

  questiondsIdLinks : number[] = [];
  questions: Question[]= [];
  result: Question;
  option: Options;

  popupService: PopupService;

  constructor(private dialog: MatDialog, private surveyService: SurveyAnswerService) { }

  ngOnInit(): void {
    this.popupService = new PopupService(this.dialog)
    this.option = this.Question.options[0];

    if (this.option.result) {
      this.treatEditSurvey(this.SurveyBase);
    }
  }

  searchLink() {
    if (this.timer) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.panelOpenState = false;
    }, 5000);

    this.show = true
    let option = this.Question.options[0];
    let links: Links[] = option.links;
    if (option.result != "" && links.length > 0) {
      this.questiondsIdLinks = [];
      this.questions = [];

      links.forEach(link => {
        this.questiondsIdLinks.push(link.questionDestinationId);
        /** Open popus */
        if (link.popupDestinationId != null) {
          this.popupService.openPopupDialog(link.popupDestinationId, this.SurveyBase);
        }

        /**open tip */
        if (link.tipDestinationTipId != null) {
          this.popupService.openTipDialog(link.tipDestinationTipId);
        }
      });

      this.questiondsIdLinks.forEach(link => {
        this.result = this.SurveyBase.questions.find(x => x.id == link);
        if (this.result != null) {
          this.questions.push(this.result);
        }
      })
    }
  }

  treatEditSurvey(survey) {
    this.panelOpenState = false;
    this.show = true;
    this.Question.options[0].links.forEach(element => {
      this.questiondsIdLinks.push(element.questionDestinationId);
    });

    this.questiondsIdLinks.forEach(element => {
      this.result = this.SurveyBase.questions.find(x => x.id == element);
      if (this.result) {
        this.questions.push(this.result);
      }
    })
  }
}
